import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import {Dropdown} from '../dropdown';

import styles from './popover.module.styl';

import type {DropdownProps} from '../dropdown';
import type {ComponentPropsWithoutRef} from 'react';

const classNames = withCssModule(styles);

const defaultArrowProps: DropdownProps['arrowProps'] = {
    componentProps: {
        height: 10,
        width: 14,
    },
    padding: 32,
};

const defaultAllowedPlacements: DropdownProps['allowedPlacements'] = ['right-end', 'right-start', 'left-end', 'left-start', 'top-end', 'top-start', 'bottom-end', 'bottom-start'];

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface PopoverProps extends DropdownProps {}

/**
 * Popover
 *
 * https://storybook.dev.pitchbookdata.com/?path=/docs/hover-popover--documentation
 */
export function Popover(props: PopoverProps) {
    const {
        hoverable = true,
        allowedPlacements = defaultAllowedPlacements,
        bodyComponent = PopoverBody,
        arrowProps = defaultArrowProps,
        verticalOffset = 7,
        className,
        maxHeight = 0,
        maxWidth = 0,
        ...dropdownProps
    } = props;

    return (
        <Dropdown
            bodyComponent={bodyComponent}
            hoverable={hoverable}
            allowedPlacements={allowedPlacements}
            verticalOffset={verticalOffset}
            arrowProps={arrowProps}
            maxHeight={maxHeight}
            maxWidth={maxWidth}
            {...dropdownProps}
            className={classNames('popover', className)}
        />
    );
}

function PopoverBody(props: ComponentPropsWithoutRef<'div'>) {
    return (
        <div {...props} className={classNames('popover_body styled-scroll-bar', props.className)}/>
    );
}
